import { __assign } from "tslib";
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import clsx from 'clsx';
import CheckIcon from '@material-ui/icons/Check';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        root: __assign(__assign({}, theme.typography.body2), (_a = { width: theme.spacing(2.5), height: theme.spacing(2.5), borderRadius: '50%', backgroundColor: theme.palette.background.paper, boxSizing: 'border-box', border: "solid 2px " + theme.palette.secondary.light, display: 'flex', alignItems: 'center', justifyContent: 'center', color: theme.palette.secondary.contrastText }, _a[theme.breakpoints.up('sm')] = {
            color: theme.palette.secondary.light,
        }, _a)),
        active: {
            backgroundColor: theme.palette.secondary.light,
        },
        completed: {
            backgroundColor: theme.palette.secondary.light,
        },
        checkIcon: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.light,
            borderRadius: '50%',
            zIndex: 1,
            width: theme.spacing(2),
            height: theme.spacing(2),
        },
        stepNumber: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                display: 'none',
            },
            _b),
    });
});
export var StepIcon = function (props) {
    var classes = useStyles();
    var active = props.active, completed = props.completed, icon = props.icon;
    return (React.createElement("div", { className: clsx(classes.root, active && classes.active, completed && classes.completed) }, completed ? (React.createElement(CheckIcon, { className: classes.checkIcon })) : active ? (React.createElement("span", { className: classes.stepNumber }, icon)) : null));
};
//# sourceMappingURL=StepIcon.js.map